import { FC } from 'react'

interface AlertPanelProps {
  title: string
  message: string
}

const AlertPanel: FC<AlertPanelProps> = ({ title, message }) => (
  <section className='w-100 bg-white pv6 ph4 shadow-black-1' data-testid='smartsearch-alert-panel'>
    <h2 className='f4 b black pb0 lh-title'>{title}</h2>
    <p className='grey mb3 ws-normal f5 wb-word overflow-hidden'>{message}</p>
  </section>
)

export default AlertPanel
